// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LoginPage.css";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import azure from "../assets/microsoft.svg";
// import google from '../assets/g.svg';
// import microsoftLogo from  "../assets/microsoftLogo.svg";
// import googleLogo from  "../assets/googleLogo.svg";
// import financeMarket from '../assets/mcv_login_page_image.png';
// import brandAsureLogo from '../assets/brand_assure_logo.svg';

// const LoginPage = () => {
//   const navigate = useNavigate();
//   const [emailId, setEmailId] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoginDisabled, setIsLoginDisabled] = useState(true);

//   useEffect(() => {
//     // Enable or disable the login button based on input values
//     if (emailId.trim() && password.trim()) {
//       setIsLoginDisabled(false);
//     } else {
//       setIsLoginDisabled(true);
//     }
//   }, [emailId, password]);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`/mcv/standard-login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email: emailId, password: password }),
//       });
//       const data = await response.json();
//       console.log("RESPPPPSPSPPS: ", data);
//       if (response.status === 200 && data.status === "success") {
//         localStorage.setItem("logoutToggle", "true"); // Set logoutToggle to false on successful login
//         localStorage.setItem("userData", JSON.stringify(data.user_details));
//         navigate("/mcv/");
//       } else {
//         alert(data.data || "Login failed. Please check your credentials.");
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       alert(
//         "An error occurred during login. Please check your connection and try again."
//       );
//     }
//   };

//   // Redirect the user to the Microsoft login page
//   const redirectToMicrosoftLogin = () => {
//     window.location.href = "/mcv/microsoft/login";
//   };

//   // Redirect the user to the Google login page
//   const redirectToGoogleLogin = () => {
//     window.location.href = `/mcv/google/login`;
//   };


//   return (
//     <div className="login-container-signup">
//       <div className="right-container">
//         {/* <div className="app-heading">Market Content Validator</div> */}
//         <img src={financeMarket} alt="Finance Market" className="background-image" />
//       </div>
//       <div className="login-left-container">
//         <form onSubmit={handleLogin} className="sign-up-login">
//           {/* <div className="sign-up-text">
//             <h2>Sign in</h2>
//           </div> */}
//           <div className="brand-assure-login-logo">
//             <img src={brandAsureLogo} alt="BrandAssure" className="brand-assure-image" />
//           </div>
//           <div className="login-header">
//             <div className='login-page-header'>Login</div>
//           </div>
//           {/* <div className="login-input-label-signup">Email ID</div> */}
//           <div className="login-page-tooltip">
//             <input
//               className="login-email-input"
//               type="text"
//               style={{ cursor: "not-allowed" }}
//               value={emailId}
//               onChange={(e) => setEmailId(e.target.value)}
//               disabled
//               // placeholder="Enter your email"
//               placeholder="Email ID"
//             />
//             <span className="login-page-tooltiptext">Try with MS or Google Login option</span>
//           </div>
//           {/* <div className="login-input-label-signup">Password</div> */}
//           <div className="login-password-wrapper login-page-tooltip">
//             <input
//               className="login-password-input"
//               type={showPassword ? "text" : "password"}
//               style={{ cursor: "not-allowed"}}
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               disabled
//               // placeholder="Enter your Password"
//               placeholder="Password"
//             />
//             <span className="login-page-tooltiptext">Try with MS or Google Login option</span>
//             <span
//               className="login-password-toggle"
//               disabled
//               style={{ cursor: "not-allowed"}}
//               // onClick={() => setShowPassword(!showPassword)}
//             >
//               {showPassword ? <FaEye /> : <FaEyeSlash />}
//             </span>
//           </div>
//             {/* <div className="submit-container"> */}
//               <button
//                 type="submit"
//                 className="submit-button-login"
//                 style={{ cursor: "not-allowed", backgroundColor: "#b0b8c3", color: "#ffffff", pointerEvents: "none",}}
//                 disabled
//               >
//                 Login
//               </button>
//             {/* </div> */}
//           <div className="auth-separator">
//             <span>or continue with</span>
//           </div>

//           {/* <div className="login-page-button-container">
//             <div className="azure-login">
//               <img src={azure} alt="Azure Icon" onClick={redirectToMicrosoftLogin} />
//             </div>
//             <div className="google-login">
//               <img src={google} alt="Google Icon" onClick={redirectToGoogleLogin} />
//             </div>
//           </div> */}

//           <div className="oauth-buttons">
//             <div
//               className="oauth-button microsoft-button"
//               onClick={redirectToMicrosoftLogin}
//             >
//               <img src={microsoftLogo} alt="Microsoft" className="oauth-icon" />{" "}
//               Microsoft
//             </div>
//             <div
//               className="oauth-button google-button"
//               onClick={redirectToGoogleLogin}
//             >
//               <img src={google} alt="Google" className="oauth-icon" /> Google
//             </div>
//           </div>


//         </form>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;



























import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import azure from "../assets/microsoft.svg";
import google from '../assets/g.svg';
import microsoftLogo from  "../assets/microsoftLogo.svg";
import googleLogo from  "../assets/googleLogo.svg";
import financeMarket from '../assets/mcv_login_page_image.png';
import brandAsureLogo from '../assets/brand_assure_logo.svg';

const LoginPage = () => {
  const navigate = useNavigate();
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoginDisabled, setIsLoginDisabled] = useState(true);

  useEffect(() => {
    // Enable or disable the login button based on input values
    if (emailId.trim() && password.trim()) {
      setIsLoginDisabled(false);
    } else {
      setIsLoginDisabled(true);
    }
  }, [emailId, password]);

  const handleStandardLogin = async (e) => {
    e.preventDefault();

    if (!emailId || !password) {
      alert("Please enter both email and password.");
      return;
    }

    try {
      const response = await fetch("/mcv/standard-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: emailId, password }),
        credentials: "include", // Include cookies
      });

      if (response.redirected) {
        // Backend issued redirect after setting cookie — success, access-denied
        // and inactive-account all arrive this way.
        window.location.href = response.url;
      } else {
        const data = await response.json();
        alert(data.message || "Login failed. Please check your credentials.");
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("An error occurred during login. Please try again.");
    }
  };

  // Redirect the user to the Microsoft login page
  const redirectToMicrosoftLogin = () => {
    window.location.href = "/mcv/microsoft/login";
  };

  // Redirect the user to the Google login page
  const redirectToGoogleLogin = () => {
    window.location.href = `/mcv/google/login`;
  };


  return (
    <div className="login-container-signup">
      <div className="right-container">
        <img src={financeMarket} alt="Finance Market" className="background-image" />
      </div>
      <div className="login-left-container">
        {/* <form onSubmit={redirectToStandardLogin} className="sign-up-login"> */}
        <form onSubmit={handleStandardLogin} className="sign-up-login">
          <div className="brand-assure-login-logo">
            <img src={brandAsureLogo} alt="BrandAssure" className="brand-assure-image" />
          </div>
          <div className="login-header">
            <div className='login-page-header'>Login</div>
          </div>
          <div className="login-page-tooltip">
            <input
              className="login-email-input"
              type="text"
              // style={{ cursor: "not-allowed" }}
              value={emailId}
              onChange={(e) => setEmailId(e.target.value)}
              // disabled
              placeholder="Email ID"
            />
            {/* <span className="login-page-tooltiptext">Try with MS or Google Login option</span> */}
          </div>
          <div className="login-password-wrapper login-page-tooltip">
            <input
              className="login-password-input"
              type={showPassword ? "text" : "password"}
              // style={{ cursor: "not-allowed"}}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              // disabled
              placeholder="Password"
            />
            {/* <span className="login-page-tooltiptext">Try with MS or Google Login option</span> */}
            <span
              className="login-password-toggle"
              onClick={() => setShowPassword(prev => !prev)}
              style={{ cursor: "pointer" }}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
              <button
                type="submit"
                className="submit-button-login"
                // style={{ cursor: "not-allowed", backgroundColor: "#b0b8c3", color: "#ffffff", pointerEvents: "none",}}
                // disabled
              >
                Login
              </button>
          <div className="auth-separator">
            <span>or continue with</span>
          </div>

          <div className="oauth-buttons">
            <div
              className="oauth-button microsoft-button"
              onClick={redirectToMicrosoftLogin}
            >
              <img src={microsoftLogo} alt="Microsoft" className="oauth-icon" />{" "}
              Microsoft
            </div>
            <div
              className="oauth-button google-button"
              onClick={redirectToGoogleLogin}
            >
              <img src={google} alt="Google" className="oauth-icon" /> Google
            </div>
          </div>


        </form>
      </div>
    </div>
  );
};

export default LoginPage;

